export const defaultHeaders = {}
